/**
 * Returns the URL parameter value
 * 
 * @param {string} sParam The name of the parameter to check
 * @returns {string} The value of the parameter
 */
function GetURLParameter(sParam) {
    var sPageURL = window.location.search.substring(1);
    var sURLVariables = sPageURL.split('&');
    for (var i = 0; i < sURLVariables.length; i++) 
    {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) 
        {
            return sParameterName[1];
        }
    }
}

// Doc Ready
$(function() {

    let loc_search = document.location.search.length;
    let url = GetURLParameter('form_prefill');
    let $newsletterModal = $('#newsletterModal');

    // Check if Newsletter errors, show modal
    if ( document.location.search.length && GetURLParameter('newsletter_modal') == 'error' && $newsletterModal.length ) {
        $newsletterModal.modal('show')
    }

});

